/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';
import Backgrid from 'backgrid';

import './SelectOneCell.css';

const SelectOneRowCell = Backbone.View.extend({
  className: 'select-one-row-cell',

  tagName: 'td',

  events: {
    'keydown :radio': 'onKeydown',
    'change :radio': 'onChange',
    'click :radio': 'enterEditMode',
  },

  initialize(options) {
    this.column = options.column;
    if (!(this.column instanceof Backgrid.Column)) {
      this.column = new Backgrid.Column(this.column);
    }
  },

  enterEditMode() {
    this.$el.find(':radio').focus();
  },

  exitEditMode() {
    this.$el.find(':radio').blur();
  },

  onKeydown(e) {
    const command = new Backgrid.Command(e);
    if (command.passThru()) {
      return true;
    } // skip ahead to `change`
    if (command.cancel()) {
      e.stopPropagation();
      this.$el.find(':radio').blur();
    } else if (command.save() || command.moveLeft() || command.moveRight() || command.moveUp() || command.moveDown()) {
      e.preventDefault();
      e.stopPropagation();
      this.model.trigger('backgrid:edited', this.model, this.column, command);
    }
  },

  onChange(e) {
    $(':radio', this).trigger('click');
    this.model.trigger('backgrid:refresh', this.model, $(e.target).prop('checked'));

    if (!this.column.get('editable')) {
      this.$el.parents('tbody').find(':radio:not(:checked)').attr('disabled', true);
    }
  },

  render() {
    const id = this.model.get('id');
    const x = this.$el
      .empty()
      .append(`<input tabindex="-1" type="radio" name="${this.column.cid}" id="${id}" />`)
      .css('text-align', 'center')
      .show();

    if (this.model.get(this.column.get('name'))) {
      this.$(`#${id}`).attr('checked', true);
    }
    x.attr('disabled', !this.column.get('editable'));
    this.delegateEvents();
    return this;
  },
});

const SelectOneHeaderCell = SelectOneRowCell.extend({
  className: 'select-one-header-cell',

  tagName: 'th',

  initialize(options) {
    this.column = options.column;
    if (!(this.column instanceof Backgrid.Column)) {
      this.column = new Backgrid.Column(this.column);
    }
    const collection = this.collection;
    this.selectedModel = undefined;

    //WARNING: TRIGGERING BACKGRID EVENTS HAS NO EFFECT.
    
    this.listenTo(collection, 'backgrid:selected', function (model, selected) {
      if (selected) {
        this.selectedModel = model;
      }
    });

    this.listenTo(collection, 'remove', function (model) {
      if ((this.selectedModel || {}).cid === model.cid) {
        this.selectedModel = undefined;
      }
    });

    this.listenTo(collection, 'backgrid:refresh', function (model, selected) {
      this.selectedModel = model
      if (this.selectedModel) {
        this.selectedModel.trigger('backgrid:select', this.selectedModel, true);
      }
    });
  },

  render() {
    this.$el.empty().append(this.column.get('label')).show();

    if (!_.isUndefined(this.column.get('width'))) {
      this.$el.attr('width', `${this.column.get('width')}%`);
    }

    this.delegateEvents();
    return this;
  },
});

Backgrid.Grid.prototype.getSelectedModel = function () {
  let selectOneHeaderCell;
  const headerCells = this.header.row.cells;
  for (let i = 0, l = headerCells.length; i < l; i++) {
    const headerCell = headerCells[i];
    if (headerCell instanceof SelectOneHeaderCell) {
      selectOneHeaderCell = headerCell;
      break;
    }
  }

  return selectOneHeaderCell.selectedModel;
};

export default {
  SelectOneRowCell,
  SelectOneHeaderCell,
};
